var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-header",on:{"click":function($event){return _vm.nClick()}}},[_c('img',{attrs:{"src":require("@/assets/logop1.jpg"),"height":"100%"}}),_c('img',{attrs:{"src":require("@/assets/logop2.jpg"),"height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }